/* eslint-disable jsx-a11y/anchor-is-valid */

import { iData, iKeyword } from '../Utils/Types'

import amplitude from 'amplitude-js'

import React from 'react'


interface iInsights { title: string; insights: iKeyword[], select(element: iKeyword): void }

const maxWidth = 460
const GROWTH_STYLE = { 
    maxWidth, 
    maxHeight: 700,
    margin: 'auto', 
    border:'2px solid white', 
    height:'calc(100vh - 130px)', 
    backgroundColor: 'rgb(48, 48, 48)',
}


const HEADING_STYLE = { 
    color: 'white', 
    textAlign: 'center' as const,
    borderBottom: '1px solid white',
    backgroundColor: 'rgb(72, 72, 72)'
}


const GrowthList = ({insights, select}: iInsights) => <div 
    id="scrollbar"
    style={{height: 'calc(100vh - 200px)', overflow: 'auto', maxHeight: 630}} 
>
    { 
        insights.sort(({kpis: a}, {kpis: b}) => a.Impressions > b.Impressions ? -1 : 1).map((e, i) => 
            <div className='panel-block' key={i} style={{color: 'white', display: 'block'}}> 
                <nav className="level" style={{marginBottom: 0, padding: 0, paddingBottom: '0.4rem', paddingTop: '0.2rem'}}>
                    <div className="level-item" style={{display: 'block', textAlign: 'left', marginLeft: 20, minWidth: 240}}> 
                        <a className="subtitle is-4" style={{color:'deepskyblue'}} onClick={() => select(e)}> { e.name } </a>
                        <p className="subtitle is-5" style={{color: 'white'}}> 
                            { e.kpis.Impressions } 
                            <small style={{color: '#ccc'}}> Impressions </small>
                        </p>
                    </div>

                    <div className="level-item" style={{display: 'block', textAlign: 'left'}}> 
                        <p className="subtitle is-5" style={{color: 'white'}}> 
                            { e.kpis.Tweets } 
                            <small style={{color: '#ccc'}}> Tweets </small>
                        </p> 
                        <p className="subtitle is-5" style={{color: 'white'}}> 
                            { e.kpis.Likes + e.kpis.Replies + e.kpis.Replies + e.kpis.Visits } 
                            <small style={{color: '#ccc'}}> Engagements </small>
                        </p> 
                    </div>
                </nav>
            </div>
        )
    }
</div>

const GrowthPanel = ({ title, insights, select }: iInsights) => <nav className='panel' style={GROWTH_STYLE}>
    <p className='panel-heading' style={HEADING_STYLE}> { title } </p>
    <GrowthList insights={insights} select={select} title={title} />
</nav>


const searchURL = 'https://twitter.com/search?q' 
const searchMention = (user: string, mention: string) => `${searchURL}=(from%3A${user})%20(to%3A${mention.substring(1)})&src=typed_query`
const searchHashtag = (user: string, hashtag: string) => `${searchURL}=(%23${hashtag.substring(1)})%20(from%3A${user})&src=typed_query`

export const Growth = ({ data }: {data: iData}) => <div className="columns" style={{minHeight: 800}}>
    <div className="column" style={{textAlign: 'center', margin: 'auto'}}>
        <GrowthPanel 
            title={'Mentions'} 
            insights={data.mentions} 
            select={({ name }) => {
                window.open(searchMention(data.userName, name))
                amplitude.getInstance().logEvent('CLICK MENTION', { mention: name })
            }}
        />
    </div>

    <div className="column" style={{textAlign: 'center', margin: 'auto'}}>
        <GrowthPanel 
            title={'Topics'} 
            insights={data.topics}  
            select={({ name }) => {
                window.open(searchHashtag(data.userName, name))
                amplitude.getInstance().logEvent('CLICK TOPIC', { topic: name })
            }}
        />
    </div>
</div>
